'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@extern/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@extern/ui/form';
import { Input } from '@extern/ui/input';
import { Separator } from '@extern/ui/separator';
import { Text } from '@extern/ui/text';
import { zodResolver } from '@hookform/resolvers/zod';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { AuthCard } from '@/app/(auth)/_partials/auth-card';
import { AuthGoogleButton } from '@/app/(auth)/_partials/auth-google-button';
import { AuthLastUsedButtonWrap } from '@/app/(auth)/_partials/auth-last-used-badge';
import { useUtmParams } from '@/hooks/use-utm-params';
import { emailSchema } from '@/infra/schemas/auth';
import { getAllowlistedSearchParams } from '@/utils/get-allowlisted-search-params';
import { useLastAuthenticationStrategy } from '../../_hooks/use-last-authentication-strategy';
import { useSignIn } from '../_hooks/use-sign-in';
const FormSchema = z.object({
  identifier: emailSchema
});
export function SignInStartControl() {
  const $ = _c(37);
  useUtmParams();
  const searchParams = useSearchParams();
  const {
    onSignInIdentifier,
    onSignInWithGoogle,
    fetchStatus
  } = useSignIn();
  const lastAuthenticationStrategy = useLastAuthenticationStrategy();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      resolver: zodResolver(FormSchema),
      defaultValues: {
        identifier: ""
      },
      mode: "onChange"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const form = useForm(t0);
  let t1;
  if ($[1] !== onSignInIdentifier) {
    t1 = async function handleSubmit(data) {
      await onSignInIdentifier(data.identifier);
    };
    $[1] = onSignInIdentifier;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSubmit = t1;
  let t2;
  if ($[3] !== form || $[4] !== handleSubmit) {
    t2 = form.handleSubmit(handleSubmit);
    $[3] = form;
    $[4] = handleSubmit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AuthCard.Header><AuthCard.Title>Join a Community Committed to Your Career Success</AuthCard.Title><AuthCard.Description>Access company Externships, build skills, and explore careers on your terms.</AuthCard.Description></AuthCard.Header>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== form.control) {
    t4 = <AuthCard.Content><FormField control={form.control} name="identifier" render={_temp} /></AuthCard.Content>;
    $[7] = form.control;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = fetchStatus === "fetching";
  const t6 = fetchStatus === "fetching";
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <Button aria-label="Sign In" className="w-full" data-cy="sign-in" disabled={t5} isLoading={t6} type="submit">Sign in with Email</Button>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== lastAuthenticationStrategy || $[13] !== t7) {
    t8 = <AuthLastUsedButtonWrap matchStrategy="password" strategy={lastAuthenticationStrategy}>{t7}</AuthLastUsedButtonWrap>;
    $[12] = lastAuthenticationStrategy;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="relative flex w-full items-center justify-center p-3"><Separator /><span className="absolute mx-auto bg-white px-4 text-gray-dark text-sm">or</span></div>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = fetchStatus === "fetching";
  let t11;
  if ($[16] !== onSignInWithGoogle || $[17] !== t10) {
    t11 = <AuthGoogleButton isLoading={t10} label="Sign in with Google" onClick={onSignInWithGoogle} />;
    $[16] = onSignInWithGoogle;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== searchParams) {
    t12 = getAllowlistedSearchParams(searchParams);
    $[19] = searchParams;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = `/sign-up?${t12}`;
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-blue-dark hover:underline">Sign up</span>;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t13) {
    t15 = <Text body="lg" className="text-center font-medium">Don't have an account? <Link href={t13}>{t14}</Link></Text>;
    $[22] = t13;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t11 || $[25] !== t15 || $[26] !== t8) {
    t16 = <AuthCard.Footer>{t8}{t9}{t11}{t15}</AuthCard.Footer>;
    $[24] = t11;
    $[25] = t15;
    $[26] = t8;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t16 || $[29] !== t4) {
    t17 = <AuthCard>{t3}{t4}{t16}</AuthCard>;
    $[28] = t16;
    $[29] = t4;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17 || $[32] !== t2) {
    t18 = <form onSubmit={t2}>{t17}</form>;
    $[31] = t17;
    $[32] = t2;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== form || $[35] !== t18) {
    t19 = <Form {...form}>{t18}</Form>;
    $[34] = form;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  return t19;
}
function _temp(t0) {
  const {
    field
  } = t0;
  return <FormItem className="flex flex-col gap-2"><FormLabel>Email address</FormLabel><FormControl><Input autoCapitalize="none" autoComplete="email" autoCorrect="off" data-cy="username" id="username" placeholder="joe@extern.com" type="email" {...field} /></FormControl><FormMessage /></FormItem>;
}